import React from 'react';
import {
  View,
  Text,
  Modal,
  Pressable,
  StyleSheet,
} from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { LINKED_ACCOUNTS_COLORS } from '@/constants/residents/mobile/linkedAccountsColors';
import { SVG_COMPONENTS } from '@/assets/admin';
import { newInvitationStrings } from '@/constants/residents/strings';

const CloseIcon = SVG_COMPONENTS.CANCEL_X;

interface InfoBubbleModalProps {
  visible: boolean;
  onClose: () => void;
}

/**
 * Info Bubble Modal
 * Explains what information is shared when sending an invitation
 * Matches Figma design 2.l. Info bubble
 */
export const InfoBubbleModal: React.FC<InfoBubbleModalProps> = ({
  visible,
  onClose,
}) => {
  const insets = useSafeAreaInsets();

  return (
    <Modal
      visible={visible}
      animationType="fade"
      transparent={true}
      onRequestClose={onClose}
    >
      {/* Overlay */}
      <Pressable style={styles.overlay} onPress={onClose}>
        <View />
      </Pressable>

      {/* Bottom Sheet Content */}
      <View
        style={[
          styles.bottomSheet,
          { paddingBottom: Math.max(insets.bottom, 24) },
        ]}
      >
        {/* Header */}
        <View style={styles.header}>
          <Text style={styles.headerTitle}>{newInvitationStrings.howItWorks.item2.title}</Text>
          <Pressable
            style={styles.closeButton}
            onPress={onClose}
            hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}
          >
            <CloseIcon width={16} height={16} color={LINKED_ACCOUNTS_COLORS.textMuted} />
          </Pressable>
        </View>

        {/* Content */}
        <View style={styles.content}>
          <Text style={styles.descriptionText}>
            {newInvitationStrings.howItWorks.item2.detail}
          </Text>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
  },
  bottomSheet: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: LINKED_ACCOUNTS_COLORS.cardBackground,
    borderTopLeftRadius: 32,
    borderTopRightRadius: 32,
    padding: 24,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 16,
  },
  headerTitle: {
    flex: 1,
    fontSize: 18,
    fontWeight: '600',
    color: LINKED_ACCOUNTS_COLORS.textPrimary,
    lineHeight: 27,
  },
  closeButton: {
    width: 20,
    height: 20,
    alignItems: 'center',
    justifyContent: 'center',
  },
  content: {
    gap: 16,
  },
  descriptionText: {
    fontSize: 14,
    fontWeight: '400',
    color: LINKED_ACCOUNTS_COLORS.textSecondary,
    lineHeight: 21,
  },
});

